export default {
  table_ordering: 'Pöytätilaus',
  table: 'Pöytä',
  pickup_or_delivery: 'Nouto tai kotiinkuljetus',
  asap: 'Heti kun mahdollista',
  served_in: 'Tarjoillaan {{time}} min kuluttua',
  not_taking_orders: 'Ei ota tilauksia',
  not_your_table: 'Eikö tämä ole sinun pöytäsi? Skannaa oman pöytäsi koodi.',
  eating_here: {
    title: 'Syötkö paikan päällä?',
    back_to_table: 'Tilaa: {{table}}. Tuomme annoksesi luoksesi.',
    scan_code: 'Skannaa pöydän QR-koodi tilataksesi pöytään.',
  },
  notes: {
    table_unavailable: {
      title: 'Tämän pöydän QR-koodi ei enää toimi.',
      text: 'Kysy apua henkilökunnalta. Voit silti tilata noudettavaksi.',
      text_no_pickup: 'Kysy apua henkilökunnalta.',
    },
    table_ordering_off: {
      title: 'Pöytätilaus ei ole tällä hetkellä käytettävissä.',
      text: 'Voit tilata sen sijaan noudettavaksi.',
    },
    load_failed: {
      title: 'Pöytääsi ei voitu ladata.',
      text: 'Skannaa QR-koodi uudelleen.',
    },
    closed: {
      title: 'Suljettu juuri nyt.',
      text: 'Voit tilata pöytääsi {{time}} alkaen.',
      text_later: 'Voit tilata pöytääsi, kun olemme taas avoinna.',
    },
    paused: {
      title: 'Tilauksia ei oteta juuri nyt.',
      text: 'Kysy henkilökunnalta tai yritä uudelleen muutaman minuutin kuluttua.',
    },
  },
  cart: {
    closed: 'Suljettu juuri nyt. Voit tilata pöytääsi {{time}} alkaen. Ostoskorisi säilyy siihen asti.',
    closed_later: 'Suljettu juuri nyt. Ostoskorisi säilyy, kunnes olemme taas avoinna.',
    paused: 'Tilauksia ei oteta juuri nyt. Ostoskorisi säilyy. Kysy apua henkilökunnalta.',
  },
  cash_note: 'Maksa käteisellä kassalla.',
  confirmation: {
    bring_to_table: 'Tuomme tilauksesi pöytääsi.',
    your_table: 'Pöytäsi',
    moved_table: 'Siirryitkö toiseen pöytään? Kerro henkilökunnalle tilausnumerosi <strong>{{number}}</strong>.',
  },
  served: 'Tarjoiltu',
};
